import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
@Component({
  selector: 'app-servicio-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;

  newCategorias = [];

  usuario = JSON.parse(localStorage.getItem('usuario'));
  activar_super = this.usuario.es_super;

  CFDI_PATH = environment.CFDI_PATH;

  tab: number = 1;
  tieneid: boolean = false;

  categorias_id: number = null;
  presentaciones_id: number = null;
  unidades_medidas_id: number = null;

  temp_categorias_id: number = null;
  temp_presentaciones_id: number = null;
  temp_unidades_medidas_id: number = null;

  form_articulos_precios;
  form_articulos_descuentos;
  form_articulos_promociones;
  form_articulos_cupones;
  form_articulos_imagenes;
  form_articulos_impuestos;
  tamano = document.body.clientHeight;


  public productos_servicios_term: string = `${environment.CFDI_PATH}/api/v1/producto-servicio-auto?term=:keyword`;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _sanitizer: DomSanitizer) { }

    observableSource = (keyword: any): Observable<any[]> => {
    
      let url: string =  `${environment.CFDI_PATH}/api/v1/producto-servicio-auto?term=${keyword}`;
      if (keyword) {
        return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
          let data: any = response;
          return data.data;
        }));
          
      } else {
        return Observable.bind([]);
      }
    }
  ngOnInit() {

    // setTimeout(() => {
    //   console.log(this.dato.value)
    // }, 3000);

    

    this.dato = this.fb.group({
      clave: [""],
      nombre: ["", [Validators.required]],
      descripcion: [""],
      cantidad_x_envase: [""],
      codigo_barras: [""],
      es_fraccionable: [""],
      categorias_id: [6],
      presentaciones_id: [""],
      unidades_medidas_id: [""],
      costo: [""],
      porcentaje_utilidad: [""],
      clave_prod_serv: [""],
      sku: [""],
      su: [""],
      peso: [""],
      material: [""],
      articulos_precios: this.fb.array([
        this.fb.group({
          nombre: ["General", [Validators.required]],
          precio: ["", [Validators.required]],
          porcentaje_utilidad: [""],
          activo: [1]
        })
      ]),
      articulos_imagenes: this.fb.array([]),
      articulos_cupones: this.fb.array([]),
      articulos_impuestos: this.fb.group({
        impuestos: this.fb.group({
          traslados: this.fb.array([]),
          retenciones: this.fb.array([])
        })
      }),
      articulos_promociones: this.fb.array([]),
      articulos_descuentos: this.fb.array([])
    });

    this.form_articulos_precios = {
      nombre: ['', [Validators.required]],
      precio: ['', [Validators.required]],
      porcentaje_utilidad: ['', [Validators.required]],
      activo: [0]
    };

    this.form_articulos_descuentos = {
      nombre: ['', [Validators.required]],
      porcentaje_descuento: ['', [Validators.required]],
      inicio_vigencia: ['', [Validators.required]],
      fin_vigencia: ['', [Validators.required]],
      activo: [0]
    };

    this.form_articulos_promociones = {
      nombre: ['', [Validators.required]],
      tipo_promocion: ['NULL', [Validators.required]],
      cantidad_minima: [''],
      cantidad_cobrar: [''],
      monto_minimo: [''],
      porcentaje_descuento: [''],
      es_acumulable: [0],
      con_otros_descuentos: [0],
      activo: [0]
    };

    this.form_articulos_cupones = {
      codigo: ['', [Validators.required]],
      porcentaje_descuento: ['', [Validators.required]],
      inicio_vigencia: ['', [Validators.required]],
      fin_vigencia: ['', [Validators.required]],
      con_otros_descuentos: [0],
      utilizado: [0]
    };

    this.form_articulos_impuestos = {
      clave: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      factor: ['', [Validators.required]],
      cuota: ['', [Validators.required]]
    };

    this.form_articulos_imagenes = {
      imagen: ['', [Validators.required]]
    };

    let ip = 0, ie = 0, im = 0;
    this.dato.controls.categorias_id.valueChanges.
      subscribe(val => {
        if (val && ip == 0) {
          ip++;
          this.temp_categorias_id = val;
        }
      });

    this.dato.controls.presentaciones_id.valueChanges.
      subscribe(val => {
        if (val && ie == 0) {
          ie++;
          this.temp_presentaciones_id = val;
        }
      });

    this.dato.controls.unidades_medidas_id.valueChanges.
      subscribe(val => {
        if (val && im == 0) {
          im++;
          this.temp_unidades_medidas_id = val;
        }
      });

    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById('catalogos').click();
  }

  filtraCategoria(categorias){
    categorias.forEach(element => {
      if (element.id>5) {
        this.newCategorias.push(element);
      }
    });
  }

  autovalor_categoria() {
    setTimeout(() => {
      this.categorias_id = this.temp_categorias_id;
    }, 2000);
  }

  autovalor_presentacion() {
    setTimeout(() => {
      this.presentaciones_id = this.temp_presentaciones_id;
    }, 3000);
  }
  autovalor_unidad_medida() {
    setTimeout(() => {
      this.unidades_medidas_id = this.temp_unidades_medidas_id;
    }, 3000);
  }
  cambio_categoria(datos, valor) {
    let value;
    datos.forEach(element => {
      if (element.id == valor) {
        value = element.clave;
      }
    });
    let codigo = Math.floor((Math.random() * 9998) + 1);
    value = value + '' + codigo;
    this.dato.controls.clave.patchValue(value);
  }


  auto = 0;
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0)
      $('ngui-auto-complete').attr('style', $('ngui-auto-complete').attr('style') + 'z-index:999');
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">${data.nombre} </h4>
            <h6>
              <strong>Clave: </strong> ${data.clave}
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);

  }

  seleccionarValorSelect2(valor) {
    this.dato.controls.clave_prod_serv.patchValue(valor.clave);
  }

  agregar_precios_default(modelo) {
    let costo = parseFloat(this.dato.get('costo').value);
    let perce = parseFloat(this.dato.get('porcentaje_utilidad').value);
    let total = costo + (costo * (perce / 100));
    let i = 0;
    modelo.controls.forEach(element => {
      modelo.removeAt(i);
      i++;
    });
    for (let i = 0; i < 5; i++) {
      let perce = i * 5;
      let nombre = 'Precio ' + (i * 5) + '% de descuento';
      let precio: any = total - (total * (perce / 100));
      precio = precio.toFixed(2);
      if (i == 0) {
        nombre = 'Precio Publico';
        precio = total;
      }

      let form = {
        nombre: [nombre, [Validators.required]],
        precio: [precio, [Validators.required]],
        porcentaje_utilidad: [i * 5, [Validators.required]],
        activo: [i == 0 ? 1 : 0]
      };
      (<FormArray>modelo).push(this.fb.group(form));
    }
  }
  cambio_precio(precio) {
    let costo = parseFloat(this.dato.get('costo').value);
    let utili = parseFloat(this.dato.get('porcentaje_utilidad').value);
    let total = costo + (costo * (utili / 100));
    let price = parseFloat(precio.controls.precio.value);

    let nuevo: any = 100 - ((price / total) * 100);
    nuevo = nuevo.toFixed(2);

    precio.controls.porcentaje_utilidad.patchValue(nuevo);
  }
  cambio_utilidad(precio) {
    let costo = parseFloat(this.dato.get('costo').value);
    let utili = parseFloat(this.dato.get('porcentaje_utilidad').value);
    let total = costo + (costo * (utili / 100));

    let perce = parseFloat(precio.controls.porcentaje_utilidad.value);

    let nuevo: any = total - (total * (perce / 100));
    nuevo = nuevo.toFixed(2);
    precio.controls.precio.patchValue(nuevo);
  }
  cambiar_precios() {
    let costo = parseFloat(this.dato.get('costo').value);
    let perce = parseFloat(this.dato.get('porcentaje_utilidad').value);
    let total = costo + (costo * (perce / 100));
    for (let i = 0; i <= this.dato.controls.articulos_precios.value.length; i++) {
      let precios = <FormGroup>this.dato.controls.articulos_precios;
      let perce = 0;
      if (precios.controls[i]) {
        perce = precios.controls[i]['controls'].porcentaje_utilidad.value;
        let precio: any = total - (total * (perce / 100));
        precio = precio.toFixed(2);
        precios.controls[i]['controls'].precio.patchValue(precio);
      }
    }
  }


  seleccionarValorSelect(valor, modelo, catalogo) {

    for (let i = 0, len = catalogo.length; i < len; i++) {
      if (catalogo[i].id == valor && catalogo[i].id != '') {
        modelo.controls.nombre.patchValue(catalogo[i].nombre);
        break;
      }
    }

  }
}
